import { checkoutPage } from './checkout-page'
import { formPage } from './form-page'
import { productPage } from './product-page'

export { checkoutPage, formPage, productPage }
